import { render, staticRenderFns } from "./BulkTagInsertModal.ts.vue?vue&type=template&id=449a321c"
import script from "./BulkTagInsertModal.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkTagInsertModal.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BulkTagInsertModal.ts.vue?vue&type=style&index=0&id=449a321c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports